'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Dialog_module = require('../styles/Dialog.module.less.js');
var DialogContext = require('./DialogContext.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description The Dialog component is used to show content on top of an overlay that requires user interaction
 *
 * @component
 * @example
 * ```jsx
 * <Content>content</Dialog>
 * ```
 */
const Content = React__namespace.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Dialog_module.default);
    const { fullscreen } = React__namespace.useContext(DialogContext.default);
    const classNames = cx(className, 'content', {
        fullscreen,
    });
    return (React__namespace.createElement("div", { ref: ref, className: classNames, ...restProps }, children));
});
Content.defaultProps = {};
Content.displayName = 'Content';

exports.Content = Content;
//# sourceMappingURL=Content.js.map
